var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _vm.crud.props.searchToggle
        ? _c(
            "div",
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                _vm._l(_vm.queryColumns, function (col) {
                  return _c(
                    "el-col",
                    {
                      staticStyle: { "margin-bottom": "10px" },
                      attrs: { span: 6 },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "flex-shrink": "0",
                                "margin-right": "5px",
                                "font-size": "14px",
                              },
                            },
                            [_vm._v(_vm._s(col.name ? col.name : col.title))]
                          ),
                          _vm._v(" "),
                          col.type !== "Date" && col.type !== "DateTime"
                            ? _c("el-input", {
                                staticClass: "filter-item",
                                staticStyle: { flex: "1" },
                                attrs: { placeholder: "请输入" },
                                nativeOn: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.crud.toQuery($event)
                                  },
                                },
                                model: {
                                  value: _vm.query[col.title],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.query, col.title, $$v)
                                  },
                                  expression: "query[col.title]",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          col.type === "Date"
                            ? _c("el-date-picker", {
                                staticStyle: { flex: "1" },
                                attrs: {
                                  type: "daterange",
                                  "range-separator": "至",
                                  "start-placeholder": "开始日期",
                                  "end-placeholder": "结束日期",
                                  "value-format": "yyyy-MM-dd",
                                },
                                model: {
                                  value: _vm.query[col.title],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.query, col.title, $$v)
                                  },
                                  expression: "query[col.title]",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          col.type === "DateTime"
                            ? _c("el-date-picker", {
                                staticStyle: { flex: "1" },
                                attrs: {
                                  type: "datetimerange",
                                  "range-separator": "至",
                                  "start-placeholder": "开始日期",
                                  "end-placeholder": "结束日期",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                },
                                model: {
                                  value: _vm.query[col.title],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.query, col.title, $$v)
                                  },
                                  expression: "query[col.title]",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("crudOperation", { attrs: { permission: _vm.permission } }),
      _vm._v(" "),
      _c(
        "el-row",
        { staticStyle: { "margin-bottom": "30px" }, attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { span: 10, offset: 10 } }, [
            _c(
              "span",
              [
                _c(
                  "el-button",
                  {
                    staticClass: "filter-item",
                    attrs: {
                      size: "mini",
                      type: "success",
                      icon: "el-icon-search",
                    },
                    on: { click: _vm.crud.toQuery },
                  },
                  [_vm._v("搜索")]
                ),
                _vm._v(" "),
                _vm.crud.optShow.reset
                  ? _c(
                      "el-button",
                      {
                        staticClass: "filter-item",
                        attrs: {
                          size: "mini",
                          type: "warning",
                          icon: "el-icon-refresh-left",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.resetQuery()
                          },
                        },
                      },
                      [_vm._v("重置")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "filter-item",
                    attrs: {
                      loading: _vm.crud.downloadLoading,
                      disabled: !_vm.crud.data.length,
                      size: "mini",
                      type: "warning",
                      icon: "el-icon-download",
                    },
                    on: { click: _vm.crud.doExport },
                  },
                  [_vm._v("导出")]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-col",
            { staticStyle: { "text-align": "right" }, attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "text",
                    icon: "el-icon-setting",
                    size: "mini",
                  },
                  on: { click: _vm.openConfigDialog },
                },
                [_vm._v("配置")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "table-content" } },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "left", "margin-bottom": "30px" } },
            [
              _c("span", { staticStyle: { "font-size": "20px" } }, [
                _vm._v(_vm._s(_vm.tabTitle)),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.crud.loading,
                  expression: "crud.loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                border: "",
                data: _vm.crud.data,
                "header-cell-style": {
                  background: "#f6f7fa",
                  color: "#606266",
                },
                "max-height": "800",
              },
            },
            _vm._l(_vm.visibleColumns, function (col) {
              return _c("el-table-column", {
                attrs: {
                  prop: col.title,
                  label: col.name ? col.name : col.title,
                  "min-width": col.width ? col.width : 120,
                  "show-overflow-tooltip": true,
                  "column-key": col.title,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          col.penetrate == 1
                            ? _c(
                                "router-link",
                                {
                                  staticStyle: { color: "#00a0e9" },
                                  attrs: {
                                    to: {
                                      path:
                                        "/cms/cmsGenerateReport/secondSubReport/" +
                                        col.subreport,
                                      query: {
                                        rowId: col.subreport,
                                        colKey: col.subreportParams,
                                        colValue: scope.row[col.title],
                                      },
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(scope.row[col.title]) +
                                      "\n          "
                                  ),
                                ]
                              )
                            : _c("span", [
                                _vm._v(_vm._s(scope.row[col.title] || "-")),
                              ]),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("pagination"),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.configVisible,
            title: "列配置",
            width: "600px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.configVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
                height: "350px",
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    flex: "1",
                    "margin-right": "20px",
                    border: "1px solid #ebeef5",
                    "border-radius": "4px",
                    padding: "10px",
                  },
                },
                [
                  _c(
                    "h4",
                    {
                      staticStyle: {
                        margin: "0 0 10px 0",
                        "font-size": "14px",
                        "font-weight": "bold",
                      },
                    },
                    [_vm._v("可选列")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        height: "calc(100% - 30px)",
                        "overflow-y": "auto",
                      },
                    },
                    [
                      _vm._l(_vm.hiddenConfigCols, function (col) {
                        return _c(
                          "div",
                          {
                            key: col.title,
                            staticStyle: {
                              padding: "8px",
                              "margin-bottom": "8px",
                              "background-color": "#fff",
                              border: "1px solid #ebeef5",
                              "border-radius": "4px",
                              cursor: "pointer",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.toggleConfigCol(col, true)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(col.name || col.title) +
                                "\n          "
                            ),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm.hiddenConfigCols.length === 0
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "center",
                                color: "#909399",
                                padding: "20px",
                              },
                            },
                            [_vm._v("\n            暂无可选列\n          ")]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    "justify-content": "center",
                    gap: "10px",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        icon: "el-icon-arrow-right",
                        disabled: _vm.hiddenConfigCols.length === 0,
                      },
                      on: { click: _vm.moveAllToVisible },
                    },
                    [_vm._v("全部右移")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        icon: "el-icon-arrow-left",
                        disabled: _vm.visibleConfigCols.length === 0,
                      },
                      on: { click: _vm.moveAllToHidden },
                    },
                    [_vm._v("全部左移")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    flex: "1",
                    "margin-left": "20px",
                    border: "1px solid #ebeef5",
                    "border-radius": "4px",
                    padding: "10px",
                  },
                },
                [
                  _c(
                    "h4",
                    {
                      staticStyle: {
                        margin: "0 0 10px 0",
                        "font-size": "14px",
                        "font-weight": "bold",
                      },
                    },
                    [
                      _vm._v("已选列（"),
                      _c("i", { staticClass: "el-icon-rank" }),
                      _vm._v("拖拽排序）"),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        height: "calc(100% - 30px)",
                        "overflow-y": "auto",
                      },
                      attrs: { id: "subConfigSelectedList" },
                    },
                    [
                      _c(
                        "draggable",
                        {
                          staticStyle: { "min-height": "100%" },
                          attrs: {
                            options: { animation: 150, handle: ".drag-handle" },
                            element: "div",
                          },
                          model: {
                            value: _vm.visibleConfigCols,
                            callback: function ($$v) {
                              _vm.visibleConfigCols = $$v
                            },
                            expression: "visibleConfigCols",
                          },
                        },
                        _vm._l(_vm.visibleConfigCols, function (col) {
                          return _c(
                            "div",
                            {
                              key: col.title,
                              staticStyle: {
                                padding: "8px",
                                "margin-bottom": "8px",
                                "background-color": "#f5f7fa",
                                "border-radius": "4px",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-between",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: { cursor: "pointer" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleConfigCol(col, false)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(col.name || col.title))]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "el-icon-rank drag-handle",
                                    staticStyle: {
                                      cursor: "move",
                                      color: "#909399",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _vm.visibleConfigCols.length === 0
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "center",
                                color: "#909399",
                                padding: "20px",
                              },
                            },
                            [_vm._v("\n            暂无已选列\n          ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveColumnConfig },
                },
                [_vm._v("保存配置")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }